import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeHeader, BaSeParagraph, BaSeTheme } from '@base/react';
import { Role } from '../../models/role';

import './styles.scss';

const menuItens = ({ click, gestaoAmeiUrl, isAdministrador }) =>
  [
    {
      onClick: () => click('/'),
      label: 'Gestão de produtos',
      href: '/',
    },
    // A gestão de perfis fica no Gestão AMEI (outro sistema): abre em nova aba
    isAdministrador &&
      gestaoAmeiUrl && {
        onClick: () =>
          window.open(gestaoAmeiUrl, '_blank', 'noopener,noreferrer'),
        label: 'Gestão de perfis',
        href: gestaoAmeiUrl,
      },
  ].filter(Boolean);

export const LayoutHeader = ({ name }) => {
  const { navigateTo } = Sebrae.useRouter();
  const { keycloak, hasRole } = Sebrae.useAuth();
  const { getEnv } = Sebrae.useEnv();
  const [gestaoAmeiUrl, setGestaoAmeiUrl] = React.useState('');

  React.useEffect(() => {
    getEnv('gestaoAmeiUrl').then(setGestaoAmeiUrl);
  }, [getEnv]);

  const leftHeader = () => {
    return (
      <React.Fragment>
        <div style={{ flex: 1, fontSize: 18, marginLeft: '5px' }}>
          <BaSeParagraph isBold color={BaSeTheme.colors.defaultColors.white}>
            {name}
          </BaSeParagraph>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="header">
      <BaSeHeader
        menuItens={menuItens({
          click: navigateTo,
          gestaoAmeiUrl,
          isAdministrador: hasRole(Role.Administrador),
        })}
        systemName={name}
        accountProfileProps={{
          keycloak,
        }}
        logoOnClick={() => navigateTo(`/`)}
        collapsedBreakpoint="onMobileLarge"
        delimitedOnBreakpoint="desktop"
        customComponents={[
          {
            component: leftHeader,
            showOnExpanded: true,
            showOnCollapsed: false,
            showOnSidebar: false,
          },
        ]}
      />
    </div>
  );
};
